import {users as usersShared} from '@cl/shared';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import createCreativeTemplateTool from 'common/src/modules/creativeTemplates/copilot/agents/creativeTemplatesManagerAgent/tools/createCreativeTemplateTool';
import duplicateCreativeTemplateTool from 'common/src/modules/creativeTemplates/copilot/agents/creativeTemplatesManagerAgent/tools/duplicateCreativeTemplateTool';
import filterCreativeTemplatesLibraryTool from 'common/src/modules/creativeTemplates/copilot/agents/creativeTemplatesManagerAgent/tools/filterCreativeTemplatesLibraryTool';
import getCreativeTemplateInfoTool from 'common/src/modules/creativeTemplates/copilot/agents/creativeTemplatesManagerAgent/tools/getCreativeTemplateInfoTool';
import getTemplatesIdsByNameTool from 'common/src/modules/creativeTemplates/copilot/agents/creativeTemplatesManagerAgent/tools/getTemplatesIdsByNameTool';
import navigateToCreativeTemplateHomeOrSetOrTearsheetTabTool from 'common/src/modules/creativeTemplates/copilot/agents/creativeTemplatesManagerAgent/tools/navigateToCreativeTemplateHomeOrSetOrTearsheetTabTool';
import navigateToCreativeTemplatesLibraryTool from 'common/src/modules/creativeTemplates/copilot/agents/creativeTemplatesManagerAgent/tools/navigateToCreativeTemplatesLibraryTool';
import showCreativeTemplatePreviewTool from 'common/src/modules/creativeTemplates/copilot/agents/creativeTemplatesManagerAgent/tools/showCreativeTemplatePreviewTool';
import navigateToCreativeTemplateBuildOrMapTabTool from 'common/src/modules/creativeTemplates/copilot/tools/navigateToCreativeTemplateBuildOrMapTabTool';
import {doesUserHaveRole} from 'common/src/modules/roles/utils/doesUserHaveRole';
import {EntityTypeToRename} from 'common/src/modules/shared/copilot/copilot.enums';
import batchRenameEntitiesTool from 'common/src/modules/shared/copilot/tools/batchRenameEntitiesTool';
import {SkillName} from 'common/src/modules/shared/copilot/skills/skills.enums';
import skill from 'common/src/modules/shared/copilot/utils/creators/skill';
import {RoleTypeName} from 'common/src/modules/users/users.types';
import {CLStore} from 'common/src/redux/store';

function creativeTemplatesManagerSkill(store: CLStore) {
  const userHasTemplateWriteRole = doesUserHaveRole(
    usersShared.userSubject.data,
    RoleTypeName.CreativeTemplatesWrite,
  );

  const permissionsRelatedTools = userHasTemplateWriteRole
    ? [
        createCreativeTemplateTool(),
        duplicateCreativeTemplateTool(),
        batchRenameEntitiesTool({
          entityType: EntityTypeToRename.Template,
          toolName: 'batchRenameTemplates',
        }),
      ]
    : [];

  return skill({
    name: SkillName.CreativeTemplatesManager,
    description:
      'Manages creative templates — find, navigate, preview, create, duplicate, and rename templates',
    whenToUse:
      'Finding, navigating, and managing creative templates. Handles creating new templates, duplicating existing templates, batch renaming templates, previewing template content, and filtering the templates library. Can look up templates by name, navigate to template pages, and access template build or mapping tabs.',
    whenToAvoid:
      'Editing layers inside a template (that is the ad builder skill). Managing creatives (published instances of templates).',
    instructions:
      'Help the user manage creative templates. You can find templates by name, navigate to template pages, preview templates, create new templates, duplicate existing ones, and rename templates in bulk.',
    tools: [
      ...permissionsRelatedTools,
      navigateToCreativeTemplatesLibraryTool(store),
      navigateToCreativeTemplateBuildOrMapTabTool(store),
      navigateToCreativeTemplateHomeOrSetOrTearsheetTabTool(),
      getTemplatesIdsByNameTool(),
      getCreativeTemplateInfoTool(store),
      showCreativeTemplatePreviewTool(store),
      filterCreativeTemplatesLibraryTool(store),
    ],
    applicableBreadcrumbs: [
      BreadcrumbName.CreativeTemplatesLibrary,
      BreadcrumbName.CreativeTemplatePage,
    ],
  });
}

export default creativeTemplatesManagerSkill;
